Router = App.loadClass 'core::Router'
PlacementHandler = App.loadClass 'grower::handlers/placement/PlacementHandler'

class exports.PlacementRouter extends Router

    prefix: 'Placement'
    module_name: 'PlacementRouter'

    register: ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        # sidebar
        @service 'grower::Angular/Placement/PlacementService', ['$http']

        # @controller 'grower::Angular/Placement/Sidebar/SidebarController',
        #     ['$scope', '$transitions', 'Placement.Services.PlacementService', 'Core.Services.Loading', '$q', '$state', '$uibModal']

        @controller 'grower::Angular/Placement/SurveyFieldsDialogController',
            ['$scope', '$transitions', '$uibModalInstance', 'Placement.Services.PlacementService', 'survey_result']

        # report dialog
        @service 'grower::Angular/Placement/Report/ReportService', ['$http', '$window']

        @controller 'grower::Angular/Placement/Report/DialogController',
            ['$scope', '$transitions', '$uibModalInstance', '$state']

        @controller 'grower::Angular/Placement/Report/Steps/SelectYearAndCropController',
            ['$scope', '$transitions', 'Placement.Services.ReportService']

        @controller 'grower::Angular/Placement/Report/Steps/SelectSurveysController',
            ['$scope', '$transitions', 'Placement.Services.ReportService', '$uibModal']

        @controller 'grower::Angular/Placement/Report/Steps/DuplicateFieldsController',
            ['$scope', '$transitions', 'Placement.Services.ReportService']

        @controller 'grower::Angular/Placement/Report/Steps/FarmFieldController',
            ['$scope', '$transitions', 'Placement.Services.ReportService', '$uibModal']

        @controller 'grower::Angular/Placement/Report/SurveyDetailsDialogController',
            [
                '$scope',
                '$transitions',
                '$uibModalInstance',
                'Placement.Services.ReportService',
                'survey_result',
                'field'
            ]

        @controller 'grower::Angular/Placement/Report/PlanDetailsDialogController',
            [
                '$scope',
                '$transitions',
                '$uibModalInstance',
                'Placement.Services.ReportService',
                'survey_result',
                'field'
            ]

        @controller 'grower::Angular/Placement/Report/Steps/DownloadController',
            ['$scope', '$transitions', 'Placement.Services.ReportService']

    registerRoutes: ($stateProvider) ->

        # hax to make transitions to and from Rx work
        init_handler = true

        $stateProvider
            .state 'grower.placement',
                url: '/placement'
                template: '<div></div>'
                # TODO: When the SPP is actually angularized, these lines will be uncommented
                # and the inline controller will be replaced by a proper Angular controller
                #templateUrl: 'backend/grower/placement/sidebar'
                #controller: 'Placement.Controllers.SidebarController'
                onEnter: ['$state', '$ngModal', ($state, $ngModal) ->
                    # we normally want to initialize the handler, but not if
                    # we're coming from one the states that it was left open on
                    # (unless of course we're reloading the page)
                    init_handler = true
                    if App.current_page instanceof PlacementHandler and
                            $state.current.name isnt 'grower.placement'
                        for state_name in App.current_page.angular_states
                            if _.startsWith($state.current.name, state_name)
                                init_handler = false
                                break

                    # hax to add planting plan
                    $(window).on 'spp.add-planting-plan', (event, data) ->
                        $ngModal.openPlantingForm data.field_id, data.year, null, null, data.options


                    # hax to edit planting plan
                    $(window).on 'spp.edit-planting-plan', (event, data) ->
                        $ngModal.openPlantingForm data.field_id, data.year, { layers_id: data.layer_id }, null, data.options

                    # hax to add rx plan
                    $(window).on 'spp.add-planting-rx-plan', (event, data) =>
                        $state.go 'grower.planting-rx', { id: null }

                    # hax to go to placement report
                    $(window).on 'spp.placement-report', (event, data) =>
                        $state.go 'grower.placement.report'
                ]
                onExit: ['$state', ($state) ->
                    $(window).off 'spp.add-planting-plan'
                    $(window).off 'spp.edit-planting-plan'
                    $(window).off 'spp.add-planting-rx-plan'
                ]
                controller: ['$scope', ($scope) ->
                    if init_handler
                        App.current_page = new PlacementHandler()
                        App.current_page.init()
                ]

            .modalState 'grower.placement.report',
                url: '/report'
                windowClass: 'dialog_500'
                templateUrl: 'backend/grower/placement/report/dialog'
                controller: 'Placement.Controllers.DialogController'

            .state 'grower.placement.report.select_year_and_crop',
                url: ''
                views:
                    'step_content@':
                        templateUrl: 'backend/grower/placement/report/select-year-and-crop-step'
                        controller: 'Placement.Controllers.SelectYearAndCropController'

            .state 'grower.placement.report.select_surveys',
                url: ''
                views:
                    'step_content@':
                        templateUrl: 'backend/grower/placement/report/select-surveys-step'
                        controller: 'Placement.Controllers.SelectSurveysController'

            .state 'grower.placement.report.duplicate_fields',
                url: ''
                views:
                    'step_content@':
                        templateUrl: 'backend/grower/placement/report/duplicate-fields-step'
                        controller: 'Placement.Controllers.DuplicateFieldsController'

            .state 'grower.placement.report.farm_field',
                url: ''
                views:
                    'step_content@':
                        templateUrl: 'backend/grower/placement/report/farm-field-step'
                        controller: 'Placement.Controllers.FarmFieldController'

            .state 'grower.placement.report.download',
                url: ''
                views:
                    'step_content@':
                        templateUrl: 'backend/grower/placement/report/download-step'
                        controller: 'Placement.Controllers.DownloadController'